import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { matchPath, useLocation } from "react-router";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";
import { NewLeadAlerts } from "../gula/callPlan/NewLeadAlerts";
import { BriefReminder } from "../gula/brief/BriefReminder";

// Boards people work on all day use the whole screen width
const WIDE_PAGES = [
  "/clientes/*",
  "/operaciones/*",
  "/whatsapp",
  "/correo/*",
  "/web",
];

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const location = useLocation();
  const isWide = WIDE_PAGES.some((pattern) =>
    matchPath(pattern, location.pathname),
  );
  return (
    <DataImportProvider>
      <Header />
      <div className="px-4">
        <BriefReminder />
      </div>
      <main
        className={
          isWide ? "mx-auto max-w-[1920px] p-4" : "max-w-screen-xl mx-auto p-4"
        }
        id="main-content"
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <Notification />
      <NewLeadAlerts />
    </DataImportProvider>
  );
};
